import * as stylex from '@stylexjs/stylex';
import { useEffect } from "react";

import { Theme } from '@/libs/openapi';
import { useLocalStorage, useMediaQuery } from '@/libs/serenity-ui';
import { dark } from "@/libs/serenity-ui/theme";
import { $ } from "@/libs/serenity-ui/tokens.stylex";

export function useApplyTheme() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [theme] = useLocalStorage('theme', Theme.SYSTEM);

  useEffect(() => {
    // RAC renders dialogs as direct children of the body element, so in order for the theme to affect them, we need to apply it to the body
    const { className, style, "data-style-src": dataStyleSrc } = stylex.props((theme === Theme.DARK || (theme === Theme.SYSTEM && prefersDarkMode)) && dark, styles.root);

    if (className) {
      document.body.className = className;
    }
    if (style) {
      document.body.style = style as unknown as string;
    }

    if (dataStyleSrc) {
      document.body.setAttribute("data-style-src", dataStyleSrc);
    }
  }, [theme, prefersDarkMode]);
}

const styles = stylex.create({
  root: {
    backgroundColor: $.surfaceBGPrimary,
  },
});
